import { Helmet } from "react-helmet-async";

const SEO = ({
  title = "Putri Henna Artist | Jasa Henna Profesional untuk Acara Spesial",
  description = "Layanan henna profesional untuk wedding, engagement, tunangan, dan acara spesial lainnya. Pilihan paket terlengkap dengan artist berpengalaman.",
  keywords = "henna wedding, henna engagement, jasa henna, henna artist, henna profesional, henna tunangan, henna pesta, henna sumedang, henna majalengka, henna bandung",
  image = "https://tehputrihenna.com/banner.webp",
  url = "https://tehputrihenna.com",
  type = "website",
  schema = null,
}) => {
  const siteName = "Putri Henna Artist";
  const fullTitle = title.includes(siteName) ? title : `${title} | ${siteName}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={siteName} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="id_ID" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="language" content="Indonesian" />
      <meta name="geo.region" content="ID" />

      {/* Structured Data / Schema.org */}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
